import * as React from "react";
import BaseWSTmp from "./base-ws-tmp";
// 消息枚举
import { ENoticeLevel, EReadStatus, ECollectStatus } from "utils/enum/notice";

// website 登录消息模板;

interface ILoginWSTmpProps {
  content?: any;
  // 未读 Yes:已读  No:未读
  isRead?: EReadStatus;
  // 未收藏 Yes:已收藏 No:未收藏
  isCollect?: ECollectStatus;
  // 消息级别
  isNoticeLevel?: ENoticeLevel;
  // 消息数量
  noticeNum?: number;
}

class LoginWSTmp extends React.Component<ILoginWSTmpProps, any> {
  constructor(props: ILoginWSTmpProps) {
    super(props);
  }

  render() {
    const slot = <div className="notice-text">{this.props.content}</div>;
    return <BaseWSTmp {...this.props} slot={slot} />;
  }
}

export default LoginWSTmp;
